export const maybeBase64EncodeWithHandler = (file, handler) => {
    // A utility function that encodes a file into base64 and calls the
    // given handler with the base64 data
    // If the file is a pdf, call with the File object directly
    // Returns the FileReader used, if any

    if (window.FileReader) {
        // Base64 encode a file and call a handler with the base64 DataURI and filename
        const fileReader = new window.FileReader();
        // Convert the image into a base64-encoded Data URI
        fileReader.readAsDataURL(file);
        fileReader.onload = (result) => {
            handler(result.target.result);
        };
        return fileReader;
    }
    return null;
};

export const isFilePdf = (file) => {
    if (file) {
        return file.type === 'application/pdf';
    }
    return false;
};
